module.exports = __webpack_public_path__ + "img/en_ca.bff0f056.png";